import React__default from 'react';
import styled from 'styled-components';
import { getColor } from '../styles/stylePropTypes.js';

const SIZE = {
    "1": 2,
    "2": 1.5,
    "3": 1.25,
    "4": 1
};
const CAPSIZE_BEFORE = {
    "1": "-0.1145em",
    "2": "-0.161em",
    "3": "-0.1865em",
    "4": "-0.1865em"
};
const CAPSIZE_AFTER = {
    "1": "-0.261em",
    "2": "-0.2142em",
    "3": "-0.2765em",
    "4": "-0.2765em"
};
const StyledHeading = styled.span`
  color: ${(props)=>props.color ? getColor(props.color, props.theme) : "inherit"};
  display: inline;
  font-size: ${(props)=>SIZE[props.level]}rem;
  font-weight: 800;
  margin: 0;
  text-align: ${(props)=>props.align};
  line-height: 1.125;

  /* capsize calcs to reposition text - see https://seek-oss.github.io/capsize/ */
  &::before {
    content: '';
    margin-top: ${(props)=>CAPSIZE_BEFORE[props.level]};
    display: block;
    height: 0;
  }
  &::after {
    content: '';
    margin-top: ${(props)=>CAPSIZE_AFTER[props.level]};
    display: block;
    height: 0;
  }
`;
const ELEMENT_MAP = {
    "1": "h1",
    "2": "h2",
    "3": "h3",
    "4": "h4"
};
/**
 * Generic heading component, abstracts usage of h1, h2 .etc & keeps headings consistent with system.
 */ const Heading = ({ level ="2" , children , ...props })=>{
    return React__default.createElement(StyledHeading, {
        ...props,
        level: level,
        as: ELEMENT_MAP[level]
    }, children);
};
Heading.dataId = "data-hpy-web-heading";
Heading.displayName = "Heading";

export { Heading };
